import { gql } from '@apollo/client'

export const SECURITY_PROFILE_CREATE_MUTATION = gql`
  mutation SECURITY_PROFILE_CREATE_MUTATION($companyId: ID, $input: SecurityProfileInput!) {
    securityProfileCreate(companyId: $companyId, input: $input) {
      data {
        id
      }
    }
  }
`

export const SECURITY_PROFILE_UPDATE_MUTATION = gql`
  mutation SECURITY_PROFILE_UPDATE_MUTATION($id: ID!, $companyId: ID, $input: SecurityProfileInput!) {
    securityProfileUpdate(id: $id, companyId: $companyId, input: $input) {
      data {
        id
      }
    }
  }
`

export const SECURITY_PROFILE_DELETE_MUTATION = gql`
  mutation SECURITY_PROFILE_DELETE_MUTATION($id: ID!, $companyId: ID) {
    securityProfileDelete(id: $id, companyId: $companyId) {
      ok
    }
  }
`
